import { Button, CircularProgress, MenuItem, TextField } from "@mui/material";
import { useSetStudentApprovalStatus } from "../../api/updateStudentSituation";
import Form from "../../../../ui/components/Form";
import * as yup from "yup";
import { useGradeStudent } from "../../api/gradeStudent";
const schema = yup.object().shape({
  grade: yup.string().required("Campo obrigatório"),
  situation: yup.string().required("Campo obrigatório"),
});

const defaultValues = {
  grade: null,
  situation: null,
};

export const UpdateStudentSituation = ({
  situation,
  initialValues = defaultValues,
  enrollmentId,
  courseId,
}) => {
  const setStudentApprovalStatus = useSetStudentApprovalStatus({ courseId });
  const gradeStudent = useGradeStudent();
  const handleSubmit = (values) => {
    switch (values.sitatuation) {
      case "Manter":
        gradeStudent.mutate({ grade: values.grade, enrollmentId });
        return;
      default:
        setStudentApprovalStatus.mutate({
          situation: values.situation,
          enrollmentId,
        });
        gradeStudent.mutate({ grade: values.grade, enrollmentId });
    }
  };

  if (setStudentApprovalStatus.isLoading || gradeStudent.isLoading) {
    return <CircularProgress />;
  }
  return (
    <Form defaultValues={initialValues} schema={schema} onSubmit={handleSubmit}>
      {({ register, formState }) => {
        return (
          <>
            <TextField
              label="Nota"
              {...register("grade")}
              type="number"
              helperText={formState.errors["grade"]?.message}
              error={!!formState.errors["grade"]}
            />
            <TextField
              label="Situação"
              {...register("situation")}
              helperText={formState.errors["situation"]?.message}
              error={!!formState.errors["situation"]}
              defaultValue={situation}
              select
            >
              <MenuItem value="Concluso">Aprovado</MenuItem>
              <MenuItem value="Expirado">Reprovado</MenuItem>
              <MenuItem value="Aguardando Professo">
                Ainda não Avaliado
              </MenuItem>
            </TextField>
            <Button type="submit">Salvar</Button>
          </>
        );
      }}
    </Form>
  );
};
